import {Component, OnInit, Input, ViewEncapsulation, AfterViewInit, OnDestroy ,inject} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { PageNotificationService, AuthService, ShareDataService as SharedDataServiceGeneric} from '@signature-it/ngx-generic/services';
import { IUser } from '@signature-it/ngx-generic/interfaces';
import { ICartSummary } from '@signature-it/ngx-catalogue/interfaces';
import {CartSummaryDTO, GetTemporaryTransactionDTO, PriceDTO, ProductSolrDTO, StockDTO} from '@signature-it/ngx-catalogue/models';
import { CartService } from '@signature-it/ngx-catalogue/services';
import { CatalogueActions } from '@signature-it/ngx-catalogue/store/actions';
import { CartActions } from '@signature-it/ngx-catalogue/store/actions';
import { ProductPipe } from '@signature-it/ngx-catalogue/pipes';
import { CatalogueSelectors, CartSelectors } from '@signature-it/ngx-catalogue/store/selectors';
import {ActivatedRoute} from "@angular/router";
import { getAddToCartError , getRemoveAllItemsError } from '@signature-it/ngx-catalogue/store/selectors';
declare let _: any;

@Component({
    selector: 'cart',
    templateUrl: './cart.html',
    styleUrls: ['./cart.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CartComponentGeneric implements OnInit, AfterViewInit, OnDestroy {
    @Input('mode') mode = 'full';
    cartIframeCms = 'cart-iframe-cms';
    // TODO: create DTOs with generic properties
    cart = {
        fullJson: {},
        extra: {},
    };
    cart$: Observable<GetTemporaryTransactionDTO>;
    loading$: Observable<boolean>;
    showCart: boolean = false;
    items = {
        TransactionItems: Array<object>(),
        OrderItems: Array<object>(),
        Summary: <ICartSummary>{},
        TotalItemsPrice: 0
    };
    isContinueToCheckoutPrice = true;
    isContinueToCheckoutStock = true;
    stock$: Observable<StockDTO[]>;
    subscriptionsList$: Array<Subscription> = [];
    inventoryCheck: boolean = GenericConfig.inventoryCheck ? true : false;
    inventoryCheckType = GenericConfig.inventoryCheckType;
    showCoupon: boolean = GenericConfig.showCoupon ? true : false;
    cartCms: boolean ;
    entityType  = '';
    user:  IUser;
    protected route: ActivatedRoute;
    loadingCartByQueryParams$: Observable<string>;
    removeAllItemCart$: Observable<string>;
    sub_add: Subscription;
    sub_remove: Subscription;
    constructor(protected notifySvc: PageNotificationService,
                protected cartSvc: CartService,
                protected store$: Store<any>,
                protected productPipe: ProductPipe,
                protected authService: AuthService,
                protected shareDataGeneric: SharedDataServiceGeneric
    ) {
        this.route = inject(ActivatedRoute);
        this.loadingCartByQueryParams$ = this.store$.select(getAddToCartError)
        this.removeAllItemCart$ = this.store$.select(getRemoveAllItemsError)
        // the cart-header component is extended this component,
        // so the logic from constructor was moved to ngOnInit function
        // that is called in the extended function only if miniCart is true in config
    }

    ngOnInit(): void {
        this.cartCms = GenericConfig.cartCms;
        this._selectDataFromStore();
        this._loadCartByQueryParams();

        if (this.cartCms) {
            window.addEventListener('message', (event) => {
                if (event.data) {
                    try {
                        const data = JSON.parse(event.data);
                        if (data.iframeHeight) {
                            const height = Number.isInteger(data.iframeHeight) ? data.iframeHeight + 'px' : '100%';
                            document.getElementById('basket-iframe').style.height = height;
                        }
                    } catch (e) {}
                }
            });
        } else {
            this.getCart();

            this.cart$.subscribe(cart => {
                if (cart) {
                    this.onSuccessLoad(cart);
                }
            });

            if (this.inventoryCheck) {
                this.stock$.subscribe(stock => {
                    if (stock) {
                        this.isContinueToCheckoutStock = true;
                        this.setStockPerProduct(stock);
                    }
                });
            }
        }
        this.shareDataGeneric.showBreadcrumbs$.next(true);
    }

    _selectDataFromStore() {
        if (this.inventoryCheck) {
            this.stock$ = this.store$.select(CatalogueSelectors.getCatalogueStockList);
        }
        this.cart$ = this.store$.select(CartSelectors.getCart);
        this.loading$ = this.store$.select(CartSelectors.getLoadingUpdatedCart);
    }

    _loadCartByQueryParams() {
        this.route.queryParams.subscribe(params => {
                if (params['Products'] && params['Quantity']) {
                    const products = params['Products'].split(",");
                    const pQuantity = params['Quantity'].split(",");
                    const pData = [];
                    if (products.length != pQuantity.length) {
                        this.notifySvc.set('The number of values of the quantity does not match the number of values of the products').show();
                        this.showCart = true;
                    } else {
                        products.forEach((product, i) => {
                            pData.push({product_id: product, quantity: pQuantity[i]});
                        });

                        const action_remove = CartActions.removeAllItems();
                        this.sub_remove = this.removeAllItemCart$.subscribe(error => {
                            if (error == '')
                                return;
                            this.sub_remove.unsubscribe();
                            if (error) {
                                this.notifySvc.set('Something is wrong').show();
                            } else {
                                const action_add = CartActions.addToCart(pData);
                                this.sub_add = this.loadingCartByQueryParams$.subscribe(error => {
                                    if (error == '')
                                        return;
                                    this.sub_add.unsubscribe();
                                    if (error)
                                        this.notifySvc.set('Something is wrong').show();
                                    this.showCart = true;
                                });
                                this.store$.dispatch(action_add);
                            }
                        });
                        this.store$.dispatch(action_remove);
                    }
                } else {
                    this.showCart = true;
                }
            }
        );
    }
    ngAfterViewInit() {
        this.authService.usersData$.subscribe((user: IUser) => {
            if (user) {
                this.user = user;
                this.entityType = user.type;
            }
        });
    }

    onSuccessLoad(data) {
        if(!_.isEmpty(data)) {
            this._setItems(
                data.Transaction || {}
            );
        }
    }

    setStockPerProduct(stock) {
        _.each(this.items.TransactionItems || [], (i) => {
            let s = _.find(stock, {productCode: i.Barcode});
            i['Stock'] = s.stock || 0;
            const checkContinue = !s.stock || i.ItemQuantity > s.stock;
            if (checkContinue && this.inventoryCheck && this.inventoryCheckType == 'block_checkout' && !i['ParentLineId']) {
                this.isContinueToCheckoutStock = false;
            }
        });
    }

    onFailureLoad(error: Response) {
        this.notifySvc.set(error).show();
    }

    protected _setItems(Transaction) {
        this.isContinueToCheckoutPrice = true;
        // subscription items
        this.items.TransactionItems = this._updateItem(Transaction.TransactionItems);
        // order items
        let OrderItems = this._updateItem(Transaction.OrderItems);
        // fetch delivery item if exists
        const delivery = {'ItemCode': GenericConfig.deliveryProductCode};
        let attributes = _.find(OrderItems, delivery) || delivery;
        // remove delivery from orders list
        _.remove(OrderItems, attributes);
        this.items.OrderItems = OrderItems;
        // summary + delivery items
        this.items.Summary = CartSummaryDTO.create(attributes);
        if (this.inventoryCheck) {
            this.getStock();
        }
    }

    protected _updateItem(col) {
        let r = [];
        _.each(col || [], (i) => {
            if (i.ItemQuantity !== 0 ) {
                if ((i['PricePerItem'] instanceof PriceDTO) === false) {
                    i['PricePerItem'] = new PriceDTO(i['PricePerItem']);
                }
                if ( i['PricePerItem'].value === -1 && !i['ParentLineId'] ) {
                    this.isContinueToCheckoutPrice = false;
                }
                i = this.updateKitItems(i, col);
                if(i.SolrDoc){
                    i.SolrDoc = ProductSolrDTO.create(i.SolrDoc);
                }
                r.push(i);
            }
        });
        return r;
    }

    updateKitItems(i, transactionItems) {
        if (!i['ParentLineId']) {
            i['children'] = this.productPipe.transform(transactionItems, 'ParentLineId', i['OrderID']) || [];
            i['isOpen'] = false;
        }
        return i;
    }

    get isContinueToCheckout(): boolean {
        return this.isContinueToCheckoutPrice && this.isContinueToCheckoutStock && this.isProductsAmountWithinRange();
    }

    get hasItems(): boolean {
        return this.hasSubscription || this.hasOrders;
    }

    get hasSubscription(): boolean {
        return this.items.TransactionItems.length > 0;
    }

    get hasOrders(): boolean {
        return this.items.OrderItems.length > 0;
    }

    protected _resetCartData() {
        throw new Error('Not Implemented for generic module');
    }


    getCart() {
        const action = CartActions.getCart();
        this.store$.dispatch(action);
    }

    getStock() {
        let barcodes = _.map(this.items.TransactionItems, t => t.Barcode);
        this._getProductsStockAction(barcodes);
    }

    protected _getProductsStockAction(barcodes: Array<any>) {
        if ( barcodes ) {
            const action = CatalogueActions.getProductsStock(barcodes);
            this.store$.dispatch(action);
        }
    }

    ngOnDestroy() {
        _.each(this.subscriptionsList$, (s) => s.unsubscribe());
    }

    isProductsAmountWithinRange() {
        return GenericConfig.cartProductLimitCount?
            GenericConfig.cartProductLimitCount >= this.items.TransactionItems.length
            : true;
    }
}
